import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import { styled, useTheme } from '@mui/material/styles';
import config from '../../config.json';


const DrawerHeader = styled('div')(({ theme }) => ({

    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
}));

interface NavigationMobileProps {
    navbarMobileOpen: boolean;
    setNavbarMobileOpen: (open: boolean) => void;
    children: any;
}

export default function NavigationMobile({navbarMobileOpen, setNavbarMobileOpen, children}: NavigationMobileProps) {

    return (
        <Drawer
            //todo: move to own component
            transitionDuration={0}
            sx={{
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: config.sizing["drawerWidthMobile"],
                    // boxSizing: "border-box",
                },
            }}
            BackdropProps={{
                invisible: true,
            }}
            onClose={() => setNavbarMobileOpen(false)}
            // variant="permanent"
            anchor="left"
            open={navbarMobileOpen}
        >
            <DrawerHeader>
                <AppBar
                    sx={{
                        width: config.sizing["drawerWidthMobile"],
                        ml: 0,
                        mr: `calc(100% - ${config.sizing["drawerWidthMobile"]})`
                    }}>
                    <Toolbar>
                        <Box display='flex' flexGrow={1}>
                            {/* <Typography variant="h6" component="div">
                                {props.title}
                            </Typography> */}
                        </Box>
                        <IconButton edge="end" color="inherit" aria-label="open drawer" onClick={() => setNavbarMobileOpen(!navbarMobileOpen)} >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
            </DrawerHeader>
            <Box sx={{ overflow: "auto" }}>
                {children}
            </Box>
        </Drawer>

    );
}